import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Button, Card, Flex, Form } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { PathContext } from "../../../context/PathContext";
import { CustomLabelSelect } from "./CustomLabelSelect";

type Props = {};

export const CustomLabelList = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);

  return (
    <>
      {
        <Card
          size="small"
          title={t(
            "maintenance:ticket.creation.config.form.field.label.customLabel"
          )}
        >
          <Form.List name={[...path, "customLabels"]}>
            {(fields, { add, remove }) => (
              <Flex vertical gap="16px">
                {fields.map((field) => (
                  <CustomLabelSelect
                    key={field.name}
                    field={field}
                    onRemove={() => remove(field.name)}
                  />
                ))}
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<Icon icon="fa:plus" />}
                />
              </Flex>
            )}
          </Form.List>
        </Card>
      }
    </>
  );
});
